module.exports = __webpack_public_path__ + "static/img/circle_1.e24a458.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/circle_1.png
// module id = 7scN
// module chunks = 1